import React from "react";
import styled from "styled-components";
import { useUserSearch } from "hooks/citajteo/user/useUserSearch";
import { User } from "type/user/user.type";
import AppLink from "components/common/style/link/AppLink";
import DeleteText from "components/common/style/navigation/DeleteText";
import { useUserDelete } from "hooks/citajteo/user/useUserDelete";
import { QUERY_KEYS } from "constant/react_query";
import toast from "react-hot-toast";

const Users: React.FC = () => {
  const users = useUserSearch();
  const { userDeleteMutate } = useUserDelete({
    invalidateKeys: [QUERY_KEYS.CITAJTEO_USER_SEARCH],
  });

  const handleUserDelete = (user: User) => {
    const confirmed = window.confirm(
      `Da li želite da obrišete korisnika ${user.un}?`,
    );

    if (!confirmed) {
      return;
    }

    userDeleteMutate(user.id, {
      onSuccess: () => {
        toast.success("Uspešno brisanje korisnika.");
      },
      onError: (error) => {
        console.error("Error deleting user:", error);
        toast.error("Greška prilikom brisanja korisnika.");
      },
    });
  };

  return (
    <div>
      <NewItem>
        <AppLink to="/admin-dashboard/user-new">novi</AppLink>
      </NewItem>

      {users &&
        users.items.length > 0 &&
        users.items.map((item: User) => (
          <ListItem key={`user_${item.id}`}>
            <AppLink to={`/admin-dashboard/user-edit/${item.id}`}>
              polja
            </AppLink>
            <br />
            {item.un}
            <DeleteItem>
              <DeleteText onClick={() => handleUserDelete(item)}>
                obriši
              </DeleteText>
            </DeleteItem>
          </ListItem>
        ))}
    </div>
  );
};

export default Users;

const NewItem = styled.div`
  margin-top: 0;
`;

const ListItem = styled.div`
  margin-top: 1em;
  width: 100%;
  line-height: 1.5em;
`;

const DeleteItem = styled.div`
  margin-top: 0.5rem;
`;
